export default __webpack_public_path__ + "static/media/ok_success.a8b7f3b7.svg";